import React from 'react';
import { ProductTable } from 'components';
export const Products = () => {
	return <ProductTable />;
};